import React, { useMemo } from 'react';
import './TestimonialsMarquee.css';

const TestimonialCard = ({ testimonial }) => (
  <article className="testimonial-card">
    <div className="testimonial-quote" aria-hidden="true">
      "
    </div>
    <p className="testimonial-text">{testimonial.text}</p>
    <div className="testimonial-author">
      <strong>{testimonial.author}</strong>
      <span>{testimonial.details}</span>
    </div>
  </article>
);

const TestimonialsMarquee = ({ items }) => {
  const loop = useMemo(() => [...items, ...items], [items]);

  return (
    <div className="testimonials-marquee" aria-label="Client testimonials">
      <div className="testimonials-marquee__fade testimonials-marquee__fade--left" aria-hidden="true" />
      <div className="testimonials-marquee__fade testimonials-marquee__fade--right" aria-hidden="true" />
      <div className="testimonials-marquee__viewport">
        <div className="testimonials-marquee__track">
          {loop.map((testimonial, index) => (
            <TestimonialCard key={`${testimonial.author}-${index}`} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsMarquee;
